import { PreAccountsResponse } from '@/types/preAccount'
import { defineStore } from 'pinia'

interface States {
  preAccounts: Ref<PreAccountsResponse | null>
  searchResults: Ref<PreAccountsResponse | null>
}

export const usePreAccountsStore = defineStore('preAccounts', () => {
  const states: States = {
    preAccounts: ref(null),
    searchResults: ref(null),
  }

  const resetStore = () => {
    states.preAccounts.value = null
    states.searchResults.value = null
  }

  // Drop a pre-account from the loaded lists once it has been promoted to live
  // (it is no longer is_pre_account, so it should disappear from the views).
  const removePreAccount = (preAccountId: number) => {
    for (const list of [states.preAccounts, states.searchResults]) {
      if (!list.value) continue
      const exists = list.value.results.some((preAccount) => preAccount.id === preAccountId)
      if (!exists) continue
      list.value.results = list.value.results.filter((preAccount) => preAccount.id !== preAccountId)
      list.value.total_data = Math.max(0, list.value.total_data - 1)
    }
  }

  return {
    ...states,
    resetStore,
    removePreAccount,
  }
})
